import type {AnalyticsQuery} from 'src/types/report';

import * as React from 'react';
import useI18n from 'src/hooks/useI18n';
import {useDispatch} from 'react-redux';

import {download} from 'src/utils/redux-api';
import useAnalyticsQuery from 'src/components/analytics/useAnalyticsQuery';

import {allowedFilters} from 'src/action-creators/link-stats';


export const CsvDownloadButton = ({
  className,
  children,
  queryResolver,
  url,
  apiPath,
  isEnhancement,
}: {
  className?: string;
  apiPath?: string;
  url: string;
  queryResolver: (
    arg1: AnalyticsQuery,
    allowed?: string[],
    isEnhancement?: boolean,
  ) => AnalyticsQuery;
  children?: React.ReactNode;
  isEnhancement?: boolean;
}) => {
  const {labelI18nInstance} = useI18n();
  const t = labelI18nInstance.t;
  const dispatch = useDispatch();
  const [query] = useAnalyticsQuery();

  const handleClick = () => {
    try {
      const resolver = isEnhancement
        ? queryResolver(query, allowedFilters, isEnhancement)
        : queryResolver(query);
      dispatch(
        download(
          url,
          {
            method: 'POST',
            data: {...resolver, export: 'csv'},
            options: {
              apiPath,
            },
          },
          t,
        ),
      );
    } catch (error: any) {
      console.error('Error downloading CSV:', error);
    }
  };

  return (
    <div className={className} onClick={handleClick}>
      {children != null ? children : t('Export_CSV', 'Export CSV')}
    </div>
  );
};

export default CsvDownloadButton;
